import React, { useEffect, useState, createContext, useCallback } from 'react';
import { TableLegend } from 'shared/component/TableLegend';
import Layout from 'shared/component/Layout';
import { updateCheckboxStatus } from 'utils/updateCheckboxStatus';
import ModalScheduleCreate from './components/ModalScheduleCreate';
import ModalProfessionalSchedule from './components/ModalProfessionalSchedule';
import TableWeekHeader from './components/TableWeekHeader';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useUnitScales } from 'hook/unitScales';
import { useConfig } from 'hook/config';
import { useProfessional } from 'hook/professional/index';
import { useAgenda } from 'hook/agenda';
import { useAgendaDetails } from 'hook/agenda/details';
import { useUserScales } from 'hook/users/scales';
import GridProfessionalSchedule from './components/GridProfessionalSchedule';
import moment from 'moment';

export const ProfessionalSchedulePageContext = createContext({});

function ProfessionalSchedule() {
  const { config } = useConfig();
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const urlScaleId = (() => {
    const raw = new URLSearchParams(location.search).get('scale_id');
    const parsed = Number(raw);
    return raw && !isNaN(parsed) ? parsed : null;
  })();

  const {
    loading: loadingUnitScales,
    data: dataUnitScales,
    total: totalUnitScales,
    getUnitScales,
  } = useUnitScales();

  const {
    loading: loadingAgenda,
    data: dataUnitAgenda,
    meta,
    setData,
    getAgenda,
    createAgenda,
  } = useAgenda();

  const {
    data: userScales,
    loading: loadingUserScales,
    loaded: userScalesLoaded,
    getUserScales,
  } = useUserScales();

  const {
    data: agendaDetails,
    loading: loadingAgendaDetails,
    setData: setAgendaDetailsData,
    getAgendaDetails,
    getDetailsSimpleCard,
  } = useAgendaDetails();
  const { getOne: getOneProfessional } = useProfessional();

  const [openModalScheduleCall, setOpenModalScheduleCall] = useState(false);
  const [openModalSchedule, setOpenModalSchedule] = useState(false);
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const selectedLocalUnit = localStorage.getItem('selectedUnitProfSchedule');
  const parseSelectedUnit = selectedLocalUnit && JSON.parse(selectedLocalUnit);
  const [selectedUnit, setSelectedUnit] = useState(
    parseSelectedUnit ? parseSelectedUnit : null
  );
  const [stateScales, setStateScales] = useState([]);
  const [detailsSchedule, setDetailsSchedule] = useState(null);
  const localHospTab = localStorage.getItem('hospTabSelected');
  const parseHospTab = localHospTab && JSON.parse(localHospTab);
  const [currentTab, setCurrentTab] = useState(parseHospTab ? parseHospTab : 0);
  const scheduleLocal =
    localStorage && localStorage.getItem('selectedSchedule');
  const scheduleJsonInLocal =
    localStorage.getItem('selectedScale') && JSON.parse(scheduleLocal);
  const scheduleInArray = scheduleJsonInLocal ? scheduleJsonInLocal : [];
  const [selectedSchedule, setSelectedSchedule] = useState('');
  const [autoSelectedScaleName, setAutoSelectedScaleName] = useState(null);

  const findSelectedSchedule =
    selectedUnit &&
    scheduleInArray.find((item) => item.unit === selectedUnit.id);

  // Não herdar mais a escala do localStorage nesta tela — URL/userScales são source of truth
  const scaleJsonInLocal = [];
  const scaleInArray = [];
  const findSelectedScale = undefined;

  useEffect(() => {
    findSelectedSchedule !== undefined
      ? setSelectedSchedule(findSelectedSchedule)
      : setSelectedSchedule('');
  }, [currentTab]);

  const [weeksInMonth, setweeksInMonth] = useState(null);
  const [completedDaysCalendar, setCompletedDaysCalendar] = useState([]);

  const initialMainFilter = {
    date_start: null,
    date_end: null,
    unit_id: selectedUnit ? selectedUnit.id : '',
    scale_id: urlScaleId,
    page: 1,
    search: '',
    user_id: id,
  };

  const [mainFilter, setMainFilter] = useState(initialMainFilter);

  // Sync scale_id to URL whenever it changes
  useEffect(() => {
    const currentScaleId = new URLSearchParams(location.search).get('scale_id');
    const newScaleId = mainFilter.scale_id ? String(mainFilter.scale_id) : null;
    if (currentScaleId === newScaleId) return;
    const params = new URLSearchParams(location.search);
    if (mainFilter.scale_id) {
      params.set('scale_id', mainFilter.scale_id);
    } else {
      params.delete('scale_id');
    }
    const search = params.toString();
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : '',
    });
  }, [mainFilter.scale_id]);

  // Load user's valid scales on mount
  useEffect(() => {
    getUserScales(id);
  }, [id]);

  // Auto-select first valid scale when URL scale_id is absent or invalid
  useEffect(() => {
    if (!userScalesLoaded) return;
    if (!userScales || userScales.length === 0) return;

    const currentId = mainFilter.scale_id;
    const isValid =
      currentId && userScales.some((s) => s.id === Number(currentId));

    if (isValid) {
      setAutoSelectedScaleName(null);
      const found = userScales.find((s) => s.id === Number(currentId));
      if (found && mainFilter.scale_name !== found.name) {
        setMainFilter((old) => ({ ...old, scale_name: found.name }));
      }
      return;
    }

    const first = userScales[0];
    setMainFilter((old) => ({
      ...old,
      scale_id: first.id,
      scale_name: first.name,
    }));
    setAutoSelectedScaleName(first.name);
  }, [userScales, userScalesLoaded]);

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleOpenSearchModal = () => {
    setOpenSearchModal(true);
  };

  const handleCloseSearchModal = () => {
    setOpenSearchModal(false);
  };

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseChipScale = (filterDelete) => () => {
    setData('');
    setSelectedSchedule('');
    scaleInArray.splice(scaleInArray.indexOf(filterDelete), 1);
    localStorage.setItem('selectedScale', JSON.stringify(scaleInArray));
    const newArray = updateCheckboxStatus(filterDelete.id, false, stateScales);
    setStateScales(newArray);
    setAutoSelectedScaleName(null);
    setMainFilter({ ...mainFilter, scale_id: null });
  };

  const handleChangeTab = (event, newTab) => {
    setData('');
    setCurrentTab(newTab);
    localStorage.setItem('hospTabSelected', JSON.stringify(newTab));
  };

  const handleClickUnitTab = (unit) => {
    localStorage.setItem('selectedUnitProfSchedule', JSON.stringify(unit));
    const { id } = unit;
    getUnitScales(id, { page: 1, per_page: 20 });
    setSelectedUnit(unit);
    setAutoSelectedScaleName(null);
    setMainFilter((old) => ({
      ...old,
      unit_id: id,
      scale_id: null,
      scale_name: null,
    }));
  };

  const handleOpenModalScheduleCall = ({
    scaleData,
    schedule,
    selected_schedule,
    agenda,
    daySelected,
  }) => {
    setOpenModalScheduleCall(true);
    setDetailsSchedule({
      schedule,
      selected_schedule,
      agenda,
      scaleData,
      daySelected,
    });
  };

  const handleCloseModalScheduleCall = () => {
    setOpenModalScheduleCall(false);
  };

  const getDaysIntervalWeek = (daysMonth) => {
    var i,
      j,
      chunk = 7;
    const temporary = [];
    for (i = 0, j = daysMonth.length; i < j; i += chunk) {
      temporary.push(daysMonth.slice(i, i + chunk));
    }
    setCompletedDaysCalendar(temporary);
  };

  const handleDateChange = ({
    date_start,
    date_end,
    weeksInMonth,
    completedDaysCalendar,
  }) => {
    setweeksInMonth(weeksInMonth);
    getDaysIntervalWeek(completedDaysCalendar);
    setMainFilter((oldState) => ({
      ...oldState,
      date_start,
      date_end,
    }));
  };

  const handleGetAgenda = () => {
    const { unit_id, date_start, date_end } = mainFilter;
    if (unit_id && date_start && date_end)
      getAgenda({ ...mainFilter, scale_name: null });
  };

  const setConfigsProps = () => {
    const firstUnitOnConfig = selectedUnit
      ? selectedUnit
      : config?.hospitalData[0];

    if (config?.hospitalData && !selectedUnit) {
      setSelectedUnit(firstUnitOnConfig);
      setMainFilter((oldState) => ({
        ...oldState,
        unit_id: firstUnitOnConfig?.id,
      }));
      getUnitScales(firstUnitOnConfig?.id);
    }
  };

  const verifyIsPast = (item) => {
    const dateCard = item?.date_start;
    const today = moment();
    return moment(dateCard).diff(today, 'days') < 0;
  };

  const handleOpenSchedule = useCallback(({ item, scaleData }) => {
    if (!verifyIsPast(item)) setOpenModalSchedule(true);
    getAgendaDetails({ agenda_id: item?.id });
    setDetailsSchedule({
      ...item,
      scaleData,
    });
  }, []);

  const hasFirstIdAgenda = (data) => {
    try {
      const firstIdAgenda = data[0][0].agendas[0].id;
      return firstIdAgenda;
    } catch (err) {
      return false;
    }
  };

  const getFirstScheduleDetails = useCallback(() => {
    const firstIdAgenda = hasFirstIdAgenda(dataUnitAgenda);
    if (dataUnitAgenda.length > 0 && firstIdAgenda) {
      getAgendaDetails({ agenda_id: firstIdAgenda });
    } else {
      getOneProfessional({ id }).then((data) =>
        setAgendaDetailsData({
          user: { ...data },
          scale: { name: mainFilter?.scale_name || '' },
        })
      );
    }
  }, [dataUnitAgenda]);

  useEffect(setConfigsProps, [config]);
  useEffect(handleGetAgenda, [mainFilter, selectedUnit, currentTab]);
  useEffect(getFirstScheduleDetails, [dataUnitAgenda]);

  return (
    <Layout
      isLoading={loadingAgenda}
      handleDateChange={handleDateChange}
      title="Agenda do Profissional"
      calendarWeek={false}
      calendarMonth
      backArrow
    >
      <ProfessionalSchedulePageContext.Provider
        value={{
          scaleJsonInLocal,
          scaleInArray,
          scheduleJsonInLocal,
          scheduleInArray,
          findSelectedSchedule,
          findSelectedScale,
          dataUnitAgenda,
          openModalSchedule,
          openModalScheduleCall,
          currentTab,
          stateScales,
          mainFilter,
          openSearchModal,
          dataUnitScales,
          openFilter,
          initialMainFilter,
          loadingUnitScales,
          totalUnitScales,
          selectedUnit,
          detailsSchedule,
          agendaDetails,
          loadingAgendaDetails,
          loadingAgenda,
          selectedSchedule,
          weeksInMonth,
          completedDaysCalendar,
          meta,
          userScales,
          loadingUserScales,
          autoSelectedScaleName,
          setAutoSelectedScaleName,
          getDetailsSimpleCard,
          setSelectedSchedule,
          setAgendaDetailsData,
          handleGetAgenda,
          handleOpenSchedule,
          getUnitScales,
          createAgenda,
          getAgenda,
          handleCloseModalScheduleCall,
          handleCloseFilter,
          setStateScales,
          setMainFilter,
          handleCloseSearchModal,
          handleOpenSearchModal,
          handleOpenFilter,
          handleCloseChipScale,
          handleChangeTab,
          handleClickUnitTab,
          handleOpenModalScheduleCall,
          setOpenModalSchedule,
        }}
      >
        <TableWeekHeader />
        <GridProfessionalSchedule />
        <ModalScheduleCreate />
        <ModalProfessionalSchedule />
        {!loadingAgenda && dataUnitAgenda.length > 0 && <TableLegend />}
      </ProfessionalSchedulePageContext.Provider>
    </Layout>
  );
}

export default ProfessionalSchedule;
